import { useMemo } from 'react';

import { PARTNER_TASK_CARDS } from '#client/components/PartnerDash/PartnerNextUp/constants';
import { RA_TASK_TYPES } from '#client/constants/partnerTasks';
import { useOrderTrackerStatus } from '#client/hooks/useOrderTrackerStatus';

const SEQUENCE = ['llc_formation', 'change_of_registered_agent', 'ein_creation'];
const NO_ACTION_NEEDED_STATUSES = ['complete', 'active', 'declined', 'cancelled', 'pending', 'processing'];

function usePartnerNextUp() {
  const { loading, orderTasksWithStatus } = useOrderTrackerStatus();

  const cards = useMemo(() => {
    if (loading) {
      return [];
    }

    const taskMap = orderTasksWithStatus.reduce((acc, task) => {
      acc[task.type] = task;
      return acc;
    }, {});

    const resolveTask = (type) => {
      if (type === 'change_of_registered_agent') {
        return RA_TASK_TYPES.map((t) => taskMap[t]).find(Boolean);
      }
      return taskMap[type];
    };

    const activeIndex = SEQUENCE.findIndex((type) => {
      const task = resolveTask(type);
      return !task || !NO_ACTION_NEEDED_STATUSES.includes(task.status);
    });

    if (activeIndex === -1) {
      return [];
    }

    return SEQUENCE.slice(activeIndex).map((type, idx) => ({
      type,
      isLocked: idx > 0,
      ...PARTNER_TASK_CARDS[type]
    }));
  }, [loading, orderTasksWithStatus]);

  return { cards, loading };
}

export default usePartnerNextUp;
